module.exports = "file://" + context.plugin.urlForResourceNamed("_webpack_resources/538736b5d852e007b865ea1c74631af5.html").path();